// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hs","advertCardPhoto__image":"c-a_ht"};